// extracted by mini-css-extract-plugin
export default {"breadcrumb":"NewBreadcrumb__breadcrumb___WPaXg","inactive":"NewBreadcrumb__inactive___i2cMQ","active":"NewBreadcrumb__active___rUGM_","beta":"NewBreadcrumb__beta___YMnla"};